// OutputDetails.js
import React from "react";

const OutputDetails = ({ outputDetails }) => {
    return (
        <div className="metrics-container mt-[-40px] flex flex-col space-y-3">
            <p className="text-sm text-gray-300">
                Status:{" "}
                <span className="font-semibold px-2 py-1 rounded-md bg-[#131723] text-green-400 border border-gray-600/50">
                    {outputDetails?.status?.description}
                </span>
            </p>
            <p className="text-sm text-gray-300">
                Memory:{" "}
                <span className="font-semibold px-2 py-1 rounded-md bg-[#131723] text-blue-400 border border-gray-600/50">
                    {outputDetails?.memory}
                </span>
            </p>
            <p className="text-sm text-gray-300">
                Time:{" "}
                <span className="font-semibold px-2 py-1 rounded-md bg-[#131723] text-purple-400 border border-gray-600/50">
                    {outputDetails?.time}
                </span>
            </p>
        </div>
    );
};
export default OutputDetails;